import React, { useEffect, useState } from "react";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "../assets/Icons";
import apiClient from "../apiClient";
import { SSO_URL } from "../env";
import { CREATE_LOGIN_METHOD, FETCH_LOGIN_METHODS_DATA, UPDATE_LOGIN_METHOD } from "../apiClient/apiEndpoints";

const defaultFormValues = {
  data: "",
  type: null,
  text: "",
};

const AddLoginMethods = ({ openModal, setOpenModal, allLoginMethods, channelId, methodData, editMode, refresh }) => {
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [loginMethodData, setLoginMethodData] = useState({});

  const closeModal = () => {
    setFormValues(defaultFormValues);
    setOpenModal(false);
  };

  const handleFormValueChange = (keyName, value) => {
    setFormValues((prev) => ({ ...prev, [keyName]: value }));
  };

  const createLoginMethod = async () => {
    try {
      setLoading(true);
      const payload = {
        data: formValues.data.trim(),
        type: formValues.type?.value,
        text: formValues?.text.trim(),
      };
      const res = await apiClient.post(`${SSO_URL}${CREATE_LOGIN_METHOD}/${channelId}`, payload);
      closeModal();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      refresh();
    }
  };

  const fetchLoginMethodsList = async () => {
    try {
      const res = await apiClient.get(`${SSO_URL}${FETCH_LOGIN_METHODS_DATA}`);
      const loginDataMapping = {};
      res?.forEach((item) => {
        loginDataMapping[item.type] = item;
      });
      setLoginMethodData(loginDataMapping);
    } catch (error) {
      console.log(error);
    }
  };

  const updateLoginMethod = async () => {
    try {
      setLoading(true);
      const payload = {
        data: formValues.data.trim(),
        type: formValues.type?.value,
        text: formValues?.text.trim(),
      };
      const res = await apiClient.post(`${SSO_URL}${UPDATE_LOGIN_METHOD}/${methodData.id}`, payload);
      closeModal();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      refresh();
    }
  };

  const handleSave = async () => {
    if (editMode) {
      updateLoginMethod();
    } else {
      createLoginMethod();
    }
  };

  useEffect(() => {
    if (methodData && list?.length && editMode) {
      setFormValues({
        data: JSON.stringify(methodData?.data || {}),
        type: list.find((item) => item.value === methodData.type),
        text: methodData.text,
      });
    }
  }, [methodData, list?.length, editMode]);
  useEffect(() => {
    if (allLoginMethods?.length) {
      setList(allLoginMethods.map((e) => ({ label: e, value: e })));
    }
  }, [allLoginMethods?.length]);
  useEffect(() => {
    fetchLoginMethodsList();
  }, []);
  useEffect(() => {
    const loginType = formValues?.type?.value;
    if (loginType) {
      setFormValues((prev) => ({
        ...prev,
        text: loginMethodData[loginType]?.text || "",
        data: JSON.stringify(loginMethodData[loginType]?.data || {}),
      }));
    }
  }, [formValues?.type?.value]);

  return (
    <>
      <Modal show={openModal} size="md" centered onHide={closeModal}>
        <Modal.Header className="modalheader">
          Add Application
          <span onClick={closeModal}>
            <CloseIcon />
          </span>
        </Modal.Header>

        <Modal.Body className="pb-0">
          <div className="row">
            <div className="col-12 standardinput mt-3">
              <label>
                {" "}
                Name<span>*</span>
              </label>
              <input
                autoComplete="off"
                name="configurationname"
                className="input form-control"
                type="text"
                value={formValues.text}
                onChange={(e) => handleFormValueChange("text", e.target.value)}
              />
            </div>

            <div className="col-12 standardinput mt-3">
              <label>
                {" "}
                Data<span>*</span>
              </label>
              <input
                autoComplete="off"
                name="configurationname"
                className="input form-control"
                type="text"
                value={formValues.data}
                onChange={(e) => handleFormValueChange("data", e.target.value)}
              />
            </div>

            <div className="col-12 standardinput">
              <label className="mb-2">
                Select Login Methods <span>*</span>
              </label>
              <div className="forselect-input">
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    colors: {
                      ...theme.colors,
                      primary50: "#ca373c50",
                      primary25: "#ca373c50",
                      primary: "#ca373c70",
                      danger: "#000000",
                      neutral30: "#00000050",
                    },
                  })}
                  options={list}
                  value={formValues.type}
                  onChange={(e) => handleFormValueChange("type", e)}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="footerbtn">
          <button className="cancel" onClick={closeModal}>
            Cancel
          </button>
          {!loading ? (
            <button className="save" onClick={handleSave}>
              Save
            </button>
          ) : (
            <button className="loading save">
              <svg viewBox="25 25 50 50">
                <circle r="20" cy="50" cx="50"></circle>
              </svg>
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddLoginMethods;
